import * as JSON from "util/json";
const stringify = (value) => {
  switch (typeof value) {
    case "bigint":
      return value.toString();
    case "string":
      return value;
    default:
      return JSON.stringify(value);
  }
};
export default stringify;
